export default __webpack_public_path__ + "img/info-button.ef3b2d4d.svg";